import { recurringIntervals } from '@lucidlink/dto/validation';
import { LimitsStatus as LimitsStatusDto, } from '@lucidlink/dto/web-service-api';
export { DAYS_UNTIL_DUE_OPTIONS, } from '@lucidlink/dto/web-service-api';
export const LIMITS_STATUSES = {
    OK: LimitsStatusDto[0],
    APPROACHING: LimitsStatusDto[1],
    REACHED: LimitsStatusDto[2],
};
export const RECURRING_INTERVALS = {
    MONTHLY: recurringIntervals[0],
    ANNUAL: recurringIntervals[1],
};
